export default defineAppConfig({
  ui: {
    colors: {
      primary: 'red',
      neutral: 'slate'
    },
    // Lesbarkeits-Optimierung (Test)
    button: {
      slots: {
        // Button-Beschriftungen neu semi-bold (statt font-medium)
        base: 'font-bold'
      }
    },
    pageFeature: {
      slots: {
        // Feature-Texte leicht grösser (Desktop + Mobile)
        title: 'text-lg',
        description: 'text-base'
      }
    },
    pageSection: {
      slots: {
        // Section-Beschreibung nur auf Mobile leicht grösser (sm+ bleibt text-lg)
        description: 'text-lg'
      }
    },
    pageCard: {
      slots: {
        // Statt fixer 15px auf die Textskala – wächst so auf Desktop mit
        description: 'text-base'
      }
    },
    prose: {
      // Prose-Lauftext auf Desktop luftiger (leading-7 = 28px ist bei 18px zu eng)
      p: {
        base: 'lg:leading-8'
      },
      li: {
        base: 'lg:leading-8'
      }
    }
  }
})
